import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCartPlus } from '@fortawesome/free-solid-svg-icons'
import { withRouter, useParams } from 'react-router-dom'

import { compose } from 'redux'
import { connect } from 'react-redux'
import { actionDetailProduct } from '../../store/actions/product'
import { actionAddCart } from '../../store/actions/cart'

import { Loader } from '../../components'
import { getDiscount, formatPrecentage } from '../../helpers'

import {
  ProductInfo,
  ProductDescription,
  ProductReviews
} from './components'

const Product = ({
  history,
  product,
  cart,
  authenticate,
  dispatchDetailProduct,
  dispatchAddCart
}) => {
  const { id } = useParams()
  const [reviews, setReviews] = useState([])
  const [totalReviews, setTotalReviews] = useState(0)
  const [avgStar, setAvgStar] = useState(0)
  const [starsCount, setStarsCount] = useState({ 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 })
  const [selectedStar, setSelectedStar] = useState(null)
  const [loadingReviews, setLoadingReviews] = useState(true)
  const [pageReviews, setPageReviews] = useState(1)
  const [totalPagesReviews, setTotalPagesReviews] = useState(1)
  const limit = 20

  const fetchReviews = (productId, star = null, page = 1) => {
    setLoadingReviews(true)
    let url = `${process.env.REACT_APP_BASE_URL}review-product/${productId}?limit=${limit}&page=${page}`
    if (star !== null) {
      url += `&star=${star}`
    }
    fetch(url)
      .then((res) => res.json())
      .then((res) => {
        if (res.status && res.data) {
          setReviews(res.data.reviews || [])
          setTotalReviews(res.data.total || 0)
          setTotalPagesReviews(res.data.pages || 1)
          setPageReviews(res.data.page || page)
          if (res.data.avg_star !== undefined) setAvgStar(res.data.avg_star)
          if (res.data.stars) setStarsCount(res.data.stars)
        } else {
          setReviews([])
          setTotalReviews(0)
          setTotalPagesReviews(1)
        }
        setLoadingReviews(false)
      })
      .catch(() => {
        setReviews([])
        setTotalReviews(0)
        setTotalPagesReviews(1)
        setLoadingReviews(false)
      })
  }

  useEffect(() => {
    dispatchDetailProduct(id)
    fetchReviews(id, selectedStar, pageReviews)
  }, [id, dispatchDetailProduct])

  const handleFilterStar = (star) => {
    setSelectedStar(star)
    setPageReviews(1)
    fetchReviews(id, star, 1)
  }

  const handlePageChangeReviews = (newPage) => {
    setPageReviews(newPage)
    fetchReviews(id, selectedStar, newPage)
  }

  const handlePageHome = () => {
    history.push('/')
  }

  const handleGoBack = () => {
    history.goBack()
  }

  const handlePageCart = () => {
    history.push('/keranjang')
  }

  const outOfStock = product.payload && (
    product.payload.has_stock === false ||
    product.payload.has_stock === 0 ||
    product.payload.has_stock === '0' ||
    product.payload.has_stock === 'false' ||
    product.payload.hasStock === false
  )

  const handleAddToCart = async () => {
    if (outOfStock) return
    const precentage = await formatPrecentage(authenticate.account, product.payload.discount)
    dispatchAddCart(product.payload, getDiscount(product.payload.price, precentage), product.payload.amount)
  }

  if (!product.payload) return <Loader />

  return (
    <div className="bg-white">
      <div
        onClick={handlePageCart}
        className="floating-shop"
      >
        <a className="menu-mobile">
          <FontAwesomeIcon className="fas" icon={faCartPlus} />
        </a>
        {
          (cart.payload.length > 0)
            ? <div className="notif">{cart.payload.length}</div>
            : null
        }
      </div>

      <div className="btn-cover-mobile">
        <a onClick={handleGoBack} className="btn-kembali">Kembali</a>
        {outOfStock ? (
          <a className="btn-keranjang btn-keranjang-disabled">Stok Habis</a>
        ) : (
          <a onClick={handleAddToCart} className="btn-keranjang">Masukan keranjang</a>
        )}
      </div>

      <div className="breadcrumb-halaman">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a
                onClick={handlePageHome}
                className="clickable"
              >Beranda</a>
            </li>
            <li className="breadcrumb-item active">Detail produk</li>
          </ol>
        </nav>
      </div>

      <div className="container">
        <ProductInfo
          productPayload={product.payload}
          account={authenticate.account}
          handleGoBack={handleGoBack}
          handleAddToCart={handleAddToCart}
        />

        <ProductDescription
          description={product.payload.description}
        />

        <ProductReviews
          reviews={reviews}
          totalReviews={totalReviews}
          avgStar={avgStar}
          starsCount={starsCount}
          selectedStar={selectedStar}
          loadingReviews={loadingReviews}
          handleFilterStar={handleFilterStar}
          page={pageReviews}
          totalPages={totalPagesReviews}
          handlePageChange={handlePageChangeReviews}
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    authenticate: {
      account: state.auth.authenticate.account
    },
    product: {
      loading: state.product.detailProduct.loading,
      payload: state.product.detailProduct.payload
    },
    cart: {
      payload: state.cart.getCart.payload
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchDetailProduct: (productId) => dispatch(actionDetailProduct(productId)),
    dispatchAddCart: (product, price, quantity) => dispatch(actionAddCart(product, price, quantity))
  }
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Product)